module.exports = __webpack_public_path__ + "img/women-in-european-academies-cover.89834ef5.jpg";